import _objectSpread from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toArray from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/toArray.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import service from './request';
import { handleArrayToObject, isArray, isObject } from 'decor-core/lib/utils'; // console.log(service, 'service')

var get = service.get,
    post = service.post,
    put = service.put;
/**
 * 请求参数处理
 **/

var handleRequestParams = function handleRequestParams() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (!data.length) {
    return null;
  } // first参数是Api在具体调用的时候传递的


  var _data = _toArray(data),
      first = _data[0],
      other = _data.slice(1);

  var temp = {};
  var params = {}; // 针对传入的额外扩展参数和header参数统一合并, other存在的时候一定是额外扩展参数

  if (other.length) {
    temp = handleArrayToObject(other);

    if (temp.extras) {
      temp.extras = _objectSpread({}, handleArrayToObject(temp.extras));
    }
  } else if (first && first.extras) {
    // 当通过装饰器传递额外扩展参数的时候,且Api具体调用的地方没有传递任何参数
    temp.extras = _objectSpread({}, handleArrayToObject(first.extras));
  }

  if (isArray(first)) {
    params = first.map(function (x) {
      return _objectSpread(_objectSpread({}, x), temp.extras);
    });
  } else if (isObject(first)) {
    params = _objectSpread(_objectSpread({}, first), temp.extras);
  } else {
    params = _objectSpread({}, temp.extras);
  }

  return params;
};
/*
 * 设置基本信息
 * */


var handleSetBase = function handleSetBase() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var other = data.slice(1);

    var _handleArrayToObject = handleArrayToObject(other),
        headers = _handleArrayToObject.headers,
        config = _handleArrayToObject.config;

    var result = {}; // 请求headers

    if (key === 'headers' && headers) {
      result = {
        headers: handleArrayToObject(headers)
      };
    } // 请求config


    if (key === 'config' && config) {
      result = _objectSpread({}, handleArrayToObject(config));
    }

    return result;
  };
};
/**
 * 设置请求头
 **/


var handleSetHeader = handleSetBase('headers');
/**
 * 设置请求配置
 **/

var handleSetConfig = handleSetBase('config');
/**
 * 获取基本配置
 **/

var handleGetBase = function handleGetBase() {
  var methods = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var config = _objectSpread(_objectSpread({}, handleSetHeader(data)), handleSetConfig(data));

    if (methods === 'GET') {
      config.params = handleRequestParams(data);
    }

    return config;
  };
};
/*
 * 获取get类型请求所需要的参数
 * */


var setParams = handleGetBase('GET');
/*
 * 获取post类型请求所需要的参数
 * */

var setData = handleGetBase('POST');
/**
 * GET 请求
 **/

export var wrapperGet = function wrapperGet(url) {
  return function () {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    return get(url, setParams(params));
  };
};
/**
 * POST 请求
 **/

export var wrapperPost = function wrapperPost(url) {
  return function () {
    for (var _len2 = arguments.length, data = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      data[_key2] = arguments[_key2];
    }

    return post(url, handleRequestParams(data), setData(data));
  };
};
/**
 * PUT 请求
 **/

export var wrapperPut = function wrapperPut(url) {
  return function () {
    for (var _len3 = arguments.length, data = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      data[_key3] = arguments[_key3];
    }

    return put(url, handleRequestParams(data), setData(data));
  };
};
/**
 * POST From 请求
 **/

export var wrapperFormPost = function wrapperFormPost(url) {
  return function () {
    for (var _len4 = arguments.length, data = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      data[_key4] = arguments[_key4];
    }

    var params = handleRequestParams(data);
    var formData = Object.keys(params).reduce(function (prev, next) {
      prev.append(next, params[next]);
      return prev;
    }, new FormData());
    return post(url, formData, setData(data));
  };
};
/**
 * POST Params 请求
 **/

export var wrapperPostParams = function wrapperPostParams(url) {
  return function () {
    for (var _len5 = arguments.length, params = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      params[_key5] = arguments[_key5];
    }

    return post(url, null, setParams(params));
  };
};